<template>
  <div class="not-pro">
    <div v-if="shadow" class="clear-shadow"></div>
    <div class="key">
      <div class="line"></div>
      <div class="icon"><i-key /></div>
      <div class="line"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import ikey from '@/components/icons/key'

export default {
  props: {
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'i-key': ikey,
  },
}
</script>

<style lang="scss">
.not-pro {
  position: relative;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  > .clear-shadow {
    width: 100%;
    height: 80px;
    position: absolute;
    top: 0px;
    transform: translateY(-100%);
    background: linear-gradient(rgba(255, 255, 255, 0), #ffffff);
    z-index: 10;
  }
  > .key {
    display: flex;
    justify-content: stretch;
    align-items: center;
    gap: 12px;
    > .line {
      height: 1px;
      background: #c2c2d6;
      flex-grow: 1;
    }
    > .icon {
      width: 40px;
      height: 40px;
      border: 1px solid #c2c2d6;
      border-radius: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
@media (max-width: 576px) {
  .not-pro {
    gap: 12px;
    > .key .icon {
      width: 32px;
      height: 32px;
    }
  }
}
#app[data-theme='dark'] {
  .not-pro .clear-shadow {
    background: linear-gradient(rgba(255, 255, 255, 0), $title-color);
  }
}
</style>
